<div>
  <div class="permitArea-item">
    <strong>{{ 'permitAreaPopup.name' | translate }}:</strong>
    {{ properties.name }}
  </div>
  @if (properties.description) {
    <div class="permitArea-item white-space">
      <strong>{{ 'permitAreaPopup.description' | translate }}:</strong>
      {{ properties.description }}
    </div>
  }
  @if (properties.type) {
    <div class="permitArea-item">
      <strong>{{ 'permitAreaPopup.type' | translate }}:</strong>
      {{ properties.type }}
    </div>
  }
  @if (properties.status) {
    <div class="permitArea-item">
      <strong>{{ 'permitAreaPopup.status' | translate }}:</strong>
      {{ statusTranslation | translate }}
    </div>
  }
</div>
